<!--
 * 主页架构组件
 * @author 滕威
 * @time 2021-01-08
 *
-->
<!-- VUE模板(html)代码 start -->
<template>

</template>
<!-- VUE模板(html)代码 end -->

<!-- JS代码 start -->
<script>
// 引入axios方法
import { fun_PostAction } from "@/api/index";
export default {
  // 储存数据
  data: () => {
    return {

    };
  },
  mounted() {
    // 获取是否单点登录
    this.fun_IsSingleLogin();
  },
  // 自定义方法
  methods: {
    /**
     * 获取是否单点登录
     * @author 滕威
     */
    fun_IsSingleLogin() {
      // 调用获取加密参数接口
      fun_PostAction("/singleLogin/isSingleLogin").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 如果不启用单点登录
          if(data == "0"){
            // 调用页面方法
            this.fun_OpenLogin();
          }else{
            // 如果启用单点登录
            this.fun_GetAuthorize();
          }
        }
      });
    },
    /**
     * 调用页面方法
     */
    fun_OpenLogin(){
      // 跳往首页
      this.$router.push({path: "/login"});
    },
    /**
     * 单点登录重定向访问
     * @author 滕威
     */
    fun_GetAuthorize() {
      // 跳转
      window.location.href = '/whebd-server/singleLogin/getAuthorize';
    },
  }
};
</script>
<!-- JS代码 end -->

<!-- css样式 start-->
<style lang="scss" scoped>

</style>
<!-- css样式 end-->
